import React, { Component } from "react";

import { ReactComponent as LobbyIcon } from "assets/icons/lobby2.svg";
import { ReactComponent as RefreshIcon } from "assets/icons/refresh.svg";
import { ReactComponent as InfoIcon } from "assets/icons/gameDetails.svg";
import { ReactComponent as CashierIcon } from "assets/icons/cashInOut.svg";
import { ReactComponent as SwitchDevice } from "assets/icons/switchDevice.svg";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { ReactComponent as PreviousIcon } from "assets/icons/previous.svg";
import { ReactComponent as RotateIcon } from "assets/icons/screen-rotate.svg";

import translations from "translations";

import "./styles.scss";

class GameController extends Component {
  render() {
    return (
      <div className={`game-controller ${this.props.gameId}`}>
        <div className="row nopadding">
          <div
            className="col-auto back"
            onClick={() => {
              this.props.onPreviousClick();
            }}
          >
            <PreviousIcon />
          </div>

          <div className="col" />

          {this.props.showInfo && (
            <div
              className="col-auto info"
              title={translations("gameInfo")}
              onClick={() => {
                this.props.toggleInfo();
              }}
            >
              <InfoIcon />
            </div>
          )}
          {this.props.isResponsiveGameDisplayEnabled && (
            <div
              className="col-auto rotate"
              onClick={() => {
                this.props.onRotateClickHandler();
              }}
            >
              <RotateIcon />
            </div>
          )}
          {this.props.showCashier && (
            <div
              className="col-auto cashier"
              onClick={this.props.broadcastCashier}
              title={translations("cashIn")}
            >
              <CashierIcon />
            </div>
          )}
          {this.props.showSwitchDevice && (
            <div
              className="col-auto"
              onClick={() => {
                this.props.broadcastSwitchDevice(
                  this.props.params,
                  this.props.gameId
                );
              }}
              title={translations("switchDevice")}
            >
              <SwitchDevice />
            </div>
          )}
          {this.props.onRefreshClickHandler && (
            <div
              className="col-auto refresh"
              onClick={this.props.onRefreshClickHandler}
              title={translations("refresh")}
            >
              <RefreshIcon />
            </div>
          )}
          {this.props.onCloseGameHandler && (
            <div
              className="col-auto lobby"
              onClick={this.props.onCloseGameHandler}
              title={translations("lobby")}
            >
              <span className="badge badge-secondary ">
                <LobbyIcon /> {translations("lobby")}
              </span>
            </div>
          )}
          {this.props.onCloseGameHandler && (
            <div
              className="col-auto lobby-mobile"
              onClick={this.props.onCloseGameHandler}
              title={translations("lobby")}
            >
              <LobbyIcon />
            </div>
          )}
          {this.props.onCloseClickHandler && (
            <div
              className="col-auto close"
              onClick={this.props.onCloseClickHandler}
              title={translations("close")}
            >
              <CloseIcon />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default GameController;
